import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '/api',
  timeout: 30000,
  headers: { 'Content-Type': 'application/json' },
});

// Interceptor: adjuntar token + empresa activa (Multi Company, solo System
// Owner) desde localStorage
api.interceptors.request.use((config) => {
  const stored = localStorage.getItem('pbx-auth');
  if (stored) {
    try {
      const { state } = JSON.parse(stored);
      if (state?.token) {
        config.headers.Authorization = `Bearer ${state.token}`;
      }
      if (state?.selectedCompanyId) {
        config.headers['X-Company-Id'] = state.selectedCompanyId;
      }
    } catch { /* localStorage corrupto: sigue sin auth, el 401 fuerza re-login */ }
  }
  return config;
});

// Interceptor: manejar errores globales
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('pbx-auth');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
